import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatCard, MatCardActions, MatCardContent, MatCardHeader, MatCardTitle,} from '@angular/material/card';
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
    MatTableDataSource,
} from '@angular/material/table';
import {RouterLink} from '@angular/router';
import {Tag} from '@app/tag/models';
import {TagService} from '@app/tag/tag.service';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';

@Component({
    selector: 'frog-tags-card',
    templateUrl: './tags-card.component.html',
    styleUrls: ['./tags-card.component.scss'],
    imports: [
        MatCard,
        MatCardHeader,
        MatCardTitle,
        MatCardContent,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatCardActions,
        MatButton,
        RouterLink,
        AsyncPipe,
    ],
})
export class TagsCardComponent implements OnInit {
    public tags$: Observable<Tag[]>;
    public displayedColumns: string[];
    public dataSource: MatTableDataSource<Tag>;

    constructor(private tagService: TagService) {
        this.displayedColumns = ['name', 'count'];
        this.dataSource = new MatTableDataSource<Tag>();
    }

    ngOnInit(): void {
        const popularTagLimit = 5;
        this.tags$ = this.tagService.list(0, '', [], false, '-count').pipe(
            map((pagedResults) => pagedResults.results),
            map((tags) => tags.filter((tag) => tag.category !== 'artist')),
            tap((tags) => {
                this.dataSource.data = tags
                    .filter((tag) => tag.count > 0)
                    .slice(0, popularTagLimit);
            }),
        );
        // this.tags$ = this.tagService.tags
        //     .pipe(
        //         map(tags => tags.filter(tag => tag.category !== 'artist'))
        //     );
    }

    edit() {}
}
